import { Component, ElementRef, ViewChild } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { PdfserviceService } from 'src/app/services/pdfservice.service';
import { Router ,ActivatedRoute} from '@angular/router';
import { SettingsService } from 'src/app/services/settings.service';
import { FlightService } from 'src/app/services/flight.service';
import { DataService } from 'src/app/services/data.service';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import * as JsBarcode from 'jsbarcode';
import {CarrierCodeService} from '../../services/carrier-code.service';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css'],

})
export class TestComponent {
  [x: string]: any;
  orderId:any
  pnrData:any
  airportList:any
  carrierCode = []
  constructor(private pdfService: PdfserviceService,private route:ActivatedRoute,private SettingsService:SettingsService,private FlightService:FlightService,
   private DataService:DataService,private CarrierCodeService:CarrierCodeService){
    this.carrierCode=this.CarrierCodeService.carrierCode()

    // this.route.queryParams.subscribe((params:any) => {
    //   let data:any
    //   console.log(params)
    //   data=this.SettingsService.decodeTransformed(params?.id)
    //   console.log(data)
      
    //   this.pnrRetreive(data)
      
    // })
    this.DataService.portMessage.subscribe((message:any) => this.pnrData = message)
    if(this.pnrData){
      debounceTime(1), // Adjust the debounce time as needed
      distinctUntilChanged(),setTimeout(() => {
        this. exportToPdf()           
      }, 0);
     }
    //  this.pnrRetreive(this.orderId)
   
   
  }

  @ViewChild('contentToConvert', { static: false })
  contentToConvert!: ElementRef;

  exportToPdf() {
    const elementId = 'contentToConvert';
    const fileName = this.pnrData?.orderId;
    if(this.pnrData.type==="print"){

    this.pdfService.exportToPdf(elementId, fileName);}
    else if(this.pnrData.type==="download"){
      this.pdfService.DownloadPdf(elementId, fileName);
    }else if(this.pnrData.type==="upload"){
      this.pdfService.uploadPdf(elementId, fileName);
    }

    
  }

  pnrRetreive(data:any){
    this.FlightService.getAllData(data)
    .subscribe( {
      next : (res:any) => {
        if(res) {
         
         let data:any
         data=res  
         this.pnrData=data
          
        
        } else {    
        } 
      },error : (err) => {
        
  
  
      }
    }
  )
  }

  fligthNameFilter(item:any){
    if(item){
    let flightName:any=[]
    flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
    if(flightName.length===0){
     return item
   
   }else{
     flightName =flightName[0].flightName
     return flightName
   }}else{
    return item
   }
    }
  
    

    qrCodeData: string = 'Hello, QR Code!';
    qrCodeImageUrl: string = '';
  
    
  
  
    statuValue(itm:any){
      if(itm){
        if(itm==='B'){
          return "Confirmed"
        }
      }
      else{
        return itm;
      }

    }

    calcMgmtFeeTax(feeData:any){
      let taxAmt = 0;
      taxAmt = Number(feeData?.totalValue-feeData?.value)
      return Number(taxAmt);
    }
    calcFinalAmt(totalAmt:any,miscData:any){
      let finalAmt = 0;
      finalAmt = Number(totalAmt+miscData?.finalAmount)
      return Number(finalAmt);

    }
    generateQRCodes(item:any,index:any,source:any,destination:any,carrier:any,flight:any) {
      console.log(item)
      
      const barCodeData = "M"+(index+1)+item.lastName+"/"+ item.firstName +"\t"+item.pnr+"\n"+source+destination+carrier+" "+flight;
      return  this.qrCodeImageUrl = this.generatePDF417Barcode(barCodeData);

    //  return this.qrCodeImageUrl = this.generateQRCode(this.qrCodeData);
      
    }
   
    generatePDF417Barcode(data: string): string {
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, data, {
        format: 'CODE128',
      //  format: 'PDF417',
        displayValue: false,
      });
  
      // Return the barcode as a data URI
      return canvas.toDataURL('image/jpeg');
    }

    flightlogoFilter(item:any){
  
      if(item){
         let flightName:any=[]
      flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
      
      if(flightName.length===0){
       return item
     
     }else{
       flightName =flightName[0]?.logo
       return flightName
     }
      }else{return item}
     }
     formatTotalPrice(item:any) {
      const numericPrice = parseFloat(item);
      
      if (!isNaN(numericPrice)) {
        return numericPrice.toFixed(2) + ' INR';
      }
      return 'N/A';
    
    }
  }
